import clsx from 'clsx';
import React from 'react';

import IconCloud from '@components/Images/Rebranding/IconCloud';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';

interface CommentCountProps {
  numberOfComment: number;
  url: string;
}
const CommentsCount = ({ numberOfComment, url }: CommentCountProps) => {
  const { trackEvent } = useEventTracking();
  return (
    <a
      onClickCapture={() =>
        trackEvent(
          click({
            clickTarget: ClickTarget.ArticleCardCommenstCount,
            clickText: numberOfComment.toString(),
          })
        )
      }
      data-testid="comment-count"
      href={`${url}#comments-section`}
      className={clsx(
        'group flex items-center text-balance text-grayscale-gray hover:text-primary-magenta focus:text-primary-magenta'
      )}
    >
      <IconCloud className="w-1 mr-4 inline-block h-16 group-hover:fill-[#f32a52]" />
      <span className="font-suisse-screen text-disclosure-md">{numberOfComment}</span>
    </a>
  );
};

export default CommentsCount;
